import React from "react"
import Drawer from "@mui/material/Drawer"
import MenuIcon from "@mui/icons-material/Menu"
import CloseIcon from "@mui/icons-material/Close"
import HomeRoundedIcon from "@mui/icons-material/HomeRounded"
import LogoutIcon from "@mui/icons-material/Logout"
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded"
import { IconButton } from "@mui/material"
import { NavLink } from "react-router-dom"
import { useAuth } from "../hooks/useAuth"
import { useLocalStorage } from "../hooks/useLocalStorage"
import enlaces from "../const/enlaces"
import { canViewModule } from "../utils/moduleAccess"
import "../views/zonda-redesign.css"

const logoUrl =
  "https://firebasestorage.googleapis.com/v0/b/zonda-b0ce9.appspot.com/o/Sistema%2FLogotipo-Zonda-Vector.svg?alt=media&token=e3d435da-9937-473b-8994-f4ac1cd7b850&_gl=1*da6o61*_ga=MTA2MTM0NDcyMC4xNjc3MTAxNzk3*_ga_CW55HF8NVT*MTY4NjU5MzU3Mi4xOC4xLjE2ODY1OTM2NDkuMC4wLjA."

export default function SideBar() {
  const [open, setOpen] = React.useState(false)
  const { signOut } = useAuth()
  const [permiso] = useLocalStorage("permiso", null)

  const hasAccess = (enlace) =>
    canViewModule(permiso, enlace.permiso)

  const availableLinks = [...enlaces]
    .filter(hasAccess)
    .sort((a, b) => a.nombre.localeCompare(b.nombre))

  return (
    <>
      <button
        type="button"
        className="zonda-menu-trigger"
        onClick={() => setOpen(true)}
        aria-label="Abrir menú de módulos"
        aria-expanded={open}
      >
        <MenuIcon />
        <span>Menú</span>
        <small>Módulos</small>
      </button>

      <Drawer
        anchor="left"
        open={open}
        onClose={() => setOpen(false)}
        ModalProps={{ keepMounted: true }}
        sx={{
          zIndex: 1400,
          "& .MuiDrawer-paper": {
            width: "min(348px, 90vw)",
            boxSizing: "border-box",
            border: 0,
            backgroundColor: "#f7fafc"
          }
        }}
      >
        <aside className="zonda-nav" aria-label="Navegación principal">
          <header className="zonda-nav__header">
            <img src={logoUrl} alt="Zonda Automotive Services" />
            <IconButton
              onClick={() => setOpen(false)}
              aria-label="Cerrar menú"
              className="zonda-nav__close"
            >
              <CloseIcon />
            </IconButton>
          </header>

          <div className="zonda-nav__heading">
            <span>Navegación principal</span>
            <strong>Todos los módulos</strong>
            <small>{availableLinks.length} opciones disponibles para tu usuario</small>
          </div>

          <nav className="zonda-nav__links">
            <NavLink exact to="/inicio" className="zonda-nav__link" activeClassName="zonda-nav__link--active" onClick={() => setOpen(false)}>
              <span className="zonda-nav__link-icon"><HomeRoundedIcon /></span>
              <span>Inicio</span>
              <ArrowForwardIosRoundedIcon className="zonda-nav__arrow" />
            </NavLink>

            {availableLinks.map((enlace) => (
              <NavLink exact key={enlace.permiso} to={`/${enlace.permiso}`} className="zonda-nav__link" activeClassName="zonda-nav__link--active" onClick={() => setOpen(false)}>
                <span className="zonda-nav__link-mark" />
                <span>{enlace.nombre}</span>
                <ArrowForwardIosRoundedIcon className="zonda-nav__arrow" />
              </NavLink>
            ))}
          </nav>

          <footer className="zonda-nav__footer">
            <button type="button" onClick={signOut}>
              <LogoutIcon />
              <span>Cerrar sesión</span>
            </button>
          </footer>
        </aside>
      </Drawer>
    </>
  )
}
